import { mapGetters, mapActions } from 'vuex'

export default {
  async created() {
    await this.loadVisibilityConfig()
  },
  computed: {
    ...mapGetters({
      configForKey: 'config/configForKey',
      visibility: 'visibilityConfig/visibilityForKey',
      user: 'user/user',
    }),
    enableLoginModal() {
      const appConfig = this.configForKey('app_config')
      if (appConfig.configV2 && appConfig.configV2.defaultV2 && appConfig.configV2.defaultV2.enableLoginModal) {
        return appConfig.configV2.defaultV2.enableLoginModal
      }
      return null
    },
  },
  methods: {
    ...mapActions({
      loadVisibilityConfig: 'visibilityConfig/loadConfig',
    }),

    componentVisibility(componentName) {
      if (this.enableLoginModal) {
        return true
      }

      const config = this.visibility(componentName)
      if (!config) return this.user
      if (this.user && config) {
        if (config.userLoggedIn) {
          return config.userLoggedIn.visible
        }
        return this.user
      }
      if (!this.user && config) {
        if (config.userLoggedOut) {
          return config.userLoggedOut.visible
        }
        return this.user
      }
      return this.user
    },
  },
}
